import React from 'react'
import { CtaButtonMetadataProvider, DefaultCtaButtonContext } from '../../../contexts/cta-button-context'
import { FeatureHighlightProvider } from '../../../contexts/feature-highlight-context'
import { ImageContext, multiColSectionResponsiveImageProps } from '../../../contexts/image-context'

import { CtaDescriptionPosition, CtaDescriptionWidth, TypeSectionMultiColumn } from '../../../lib/types'
import { MultiColumnLayout } from '../../layout/multi-column'
import { PageSection } from '../../page-section'
import { ContentProps, ContentRenderer, EntryContentProps } from '../../renderer'
import { TabSection } from '../tabs/tab-section'

const MultiColumnSectionContent: React.FC<EntryContentProps<TypeSectionMultiColumn>> = (props) => {
  const {
    structure: {
      fields: { maxColumnsPerRow, minColumnsPerRow, showDividersBetweenColumns, columns, multiColumnAsSingle, compact },
    },
  } = props

  return (
    <ImageContext.Provider value={multiColSectionResponsiveImageProps}>
      <FeatureHighlightProvider value={{ titleStyle: 'T3' }}>
        <MultiColumnLayout
          multiColumnAsSingle={multiColumnAsSingle}
          maxColumnsPerRow={maxColumnsPerRow}
          minColumnsPerRow={minColumnsPerRow}
          withDivider={showDividersBetweenColumns}
          compact={compact}
        >
          {columns?.map((column, i) => (
            <div key={`${column.sys.id}-${i}`}>
              <ContentRenderer structure={column.fields.content} />
            </div>
          ))}
        </MultiColumnLayout>
      </FeatureHighlightProvider>
    </ImageContext.Provider>
  )
}

export const MultiColumnSection: React.FC<ContentProps<TypeSectionMultiColumn>> = (props) => {
  const {
    structure,
    structure: {
      sys,
      fields: { internalName, background, heading, multiColumnAsSingle },
    },
    className,
  } = props

  const multiColumnContent = (
    <CtaButtonMetadataProvider value={{ ...DefaultCtaButtonContext, descriptionPosition: CtaDescriptionPosition.Left }}>
      <MultiColumnSectionContent structure={structure} />
    </CtaButtonMetadataProvider>
  )

  if (multiColumnAsSingle) {
    return multiColumnContent
  }

  return (
    <PageSection
      internalName={internalName}
      sysStructure={sys}
      className={className}
      heading={heading}
      background={background}
    >
      {multiColumnContent}
    </PageSection>
  )
}

export const MultiColumnSectionForTabs: React.FC<ContentProps<TypeSectionMultiColumn>> = ({ className, structure }) => {
  const {
    fields: { background, heading },
  } = structure

  return (
    <TabSection className={className} heading={heading} background={background}>
      <CtaButtonMetadataProvider
        value={{
          ...DefaultCtaButtonContext,
          descriptionWidth: CtaDescriptionWidth.Fixed,
          descriptionPosition: CtaDescriptionPosition.Left,
        }}
      >
        <MultiColumnSectionContent structure={structure} />
      </CtaButtonMetadataProvider>
    </TabSection>
  )
}
